export const teamRegistrations: TableModule = {
    name: 'teamRegistrations',
    route: 'spa.organisations.teamRegistrations',
    defaultOrder: {
        column: 'invoice_id',
        direction: 'asc'
    },
    routeParams: [{
        param: 'organisation',
        prop: 'organisation_id'
    }],
    columns: [
        {
            name: 'invoice_id',
            sortable: true,
            width: 'w-[150px]'
        },
        {
            name: 'team',
            mobile: true,
        },
        {
            name: 'contest',
            mobile: true
        },
        {
            name: 'comment',
            breakpoint: 'md',
        }
    ],
    filters: [],
    quickFilters: [],
    tools: [
        {
            name: "teamRegistrations.manuallyMarkAsPayed",
            ability: ["manuallyMarkAsPayed", "contestTeamRegistrations"]
        }, {
            name: "teamRegistrations.unsubscribeTeams",
        }
    ]
}

